export const repertoireData = [
  {
    title: "10 Tunes To Start With",
    text: [
      "There Will Never Be Another You",
      "There is No Greater Love",
      "Stella By Starlight",
      "All Things You Are",
      "Blue Bossa",
      "Watermelon Man",
      "Cantaloupe Island",
      "Take The A Train",
      "I Mean You",
      "Scrapple From The Apple",
    ],
  },
  {
    title: "100 Tunes To Learn",
    text: [
      "Honeysuckle Rose",
      "Pennies From Heaven",
      "Desafinado",
      "Corcovado",
      "Invitation",
      "Daahoud",
      "The Way You Look Tonight",
      "I Could Write a Book",
      "My Romance",
      "Bewitched, Bothered & Bewildered",
      "It Could Happen to You",
      "Ain’t Misbehavin",
      "I Should Care",
      "Days of Wine & Roses",
      "Misty",
      "I Remember You",
      "I’m Getting Sentimental Over You",
      "Sweet Lorraine",
      "Up a Lazy River",
      "Half Nelson",
      "You Stepped Out of a Dream",
      "Darn that Dream",
      "Dewey Square",
      "Afternoon In Paris",
      "April in Paris",
      "Sweet & Lovely",
      "Milestones (old)",
      "Barbados",
      "Bouncin’ with Bud",
      "Cheryl",
      "Eternal Triangle",
      "Good Bait",
      "Little Willie Leaps",
      "Woody ‘n You",
      "Serenity",
      "Black Narcissus",
      "Punjab",
      "Hot House",
      "I Mean You",
      "Epistrophy",
      "Ruby My Dear",
      "Off Minor",
      "Countdown",
      "Central Park West",
      "The Night Has a Thousand Eyes",
      "But Not For Me",
      "Witch Hunt",
      "Fee Fi Fo Fum",
      "Speak No Evil",
      "Yes and No",
      "Black Nile",
      "Inner Urge",
      "Moment’s Notice",
      "Lazy Bird",
      "26­-2",
      "All of You",
      "Autumn in New York",
      "BeBop",
      "My Shining Hour",
      "The Best Thing For You Is Me",
      "Bloomdido",
      "Minority",
      "Bolivia",
      "Boplicity",
      "Bourbon Street Parade",
      "Bright Mississippi",
      "Bye-Ya",
      "Ceora",
      "CheeseCake",
      "Con Alma",
      "Dear Old Stockholm",
      "On the Sunny Side of the Street",
      "Dig",
      "Donna Lee",
      "Like Someone In Love",
      "Love For Sale",
      "Easy To Love",
      "I Love You",
      "Embraceable You",
      "Everything Happens To Me",
      "Evidence",
      "A Flower is a Lovesome Thing",
      "Let’s Cool One",
      "Our Love Is Here To Stay",
      "It’s You Or No One",
      "Groovin’ High",
      "Have You met Miss Jones",
      "Subconscious Lee",
      "Background Music",
      "April (Tristano)",
      "Our Love is Here To Stay",
      "I Hear A Rhapsody",
      "I Thought About You",
      "I’ll Be Seeing You",
      "Pent Up House",
      "If I Should Lose You",
      "Imagination",
      "In Your Own Sweet Way",
      "Just You, Just Me",
      "Joy Spring",
    ],
  },
  {
    title: "10 Blues Heads To Learn",
    text: [
      "Sonnymoon For 2",
      "Bloomdido",
      "Tenor Madness",
      "Barbados",
      "Au Privave",
      "Blues By 5",
      "Blues For Alice",
      "Things Ain't What They Used To Be",
      "Cool Blues",
      "Billie's Bounce",
    ],
  },
  {
    title: "10 Modal Tunes To Learn",
    text: [
      "So What",
      "Impressions",
      "Milestones (new)",
      "My Favorite Things",
      "Maiden Voyage",
      "Footprints",
      "Little Sunflower",
      "Black Narcissus",
      "Freedom Jazz Dance",
      "Take Five",
    ],
  },
];
